import PropTypes from 'prop-types';
import { status } from 'constants/general';
import Loader from 'modules/shared/common/components/Loader';
import Pagination from 'modules/shared/common/components/Pagination';
import VendorsHeader from 'modules/shared/vendors/components/VendorsHeader';
import VendorsList from 'modules/shared/vendors/components/VendorsList';
import VendorsFilter from 'modules/shared/vendors/components/VendorsFilter';
import Modal from 'modules/shared/common/components/Modal';
import AddOrEditVendorComponent from 'modules/shared/vendors/components/AddOrEditVendorComponent';

import { VendorsWrapper, LoaderWrapper, PaginationWrapper } from './VendorsComponent.style';

const VendorsComponent = ({
  stringsData,
  selectedPageFilter,
  numberOfPages,
  vendorsList,
  vendorTypes,
  mappedVendorsList,
  vendorStatusEnum,
  vendorStatusColorEnum,
  handleVendorsGenericFilterChange,
  handleVendorsSearchBarInputChange,
  handleVendorsPaginationClick,
  filters,
  labsQueryStrings,
  formFieldsValues,
  setFormFieldsValues,
  formFieldsValidation,
  isDetailsModalOpen,
  setIsDetailsModalOpen,
  handleConfirmDetailsModalClick,
  handleCancelDetailsModalClick,
  handleVendorEditButtonClick,
  handleDropDownFieldChange,
}) => (
  <VendorsWrapper>
    <VendorsHeader stringsData={stringsData} handelAddVendorBtnClick={setIsDetailsModalOpen} />
    <VendorsFilter
      stringsData={stringsData}
      mappedVendorsList={mappedVendorsList}
      vendorStatusEnum={vendorStatusEnum}
      vendorStatusColorEnum={vendorStatusColorEnum}
      handleVendorsGenericFilterChange={handleVendorsGenericFilterChange}
      handleVendorsSearchBarInputChange={handleVendorsSearchBarInputChange}
      filters={filters}
      labsQueryStrings={labsQueryStrings}
    />
    {vendorsList?.status === status.SUCCESS || vendorsList?.status === status.FAIL ? (
      <>
        <VendorsList
          stringsData={stringsData}
          mappedVendorsList={mappedVendorsList}
          vendorStatusEnum={vendorStatusEnum}
          vendorStatusColorEnum={vendorStatusColorEnum}
          handleVendorEditButtonClick={handleVendorEditButtonClick}
        />
        {numberOfPages > 1 && (
          <PaginationWrapper>
            <Pagination
              currentPage={selectedPageFilter}
              totalCount={numberOfPages}
              handleOrderPaginationClick={handleVendorsPaginationClick}
            />
          </PaginationWrapper>
        )}
      </>
    ) : (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    )}
    <Modal
      data-testid="AddOrEditVendorModal"
      title={
        formFieldsValues.key
          ? stringsData.vendorDetailsContent.vendorDetailsContentEditButtonLabel
          : stringsData.vendorsHeader.createVendorButton
      }
      onClose={() => handleCancelDetailsModalClick(setIsDetailsModalOpen)}
      toggle={isDetailsModalOpen}
      onConfirmHandler={() => {
        handleConfirmDetailsModalClick(setIsDetailsModalOpen);
      }}
      confirmActionLabel={
        formFieldsValues.key
          ? stringsData.vendorDetailsContent.vendorDetailsContentEditButtonLabel
          : stringsData.vendorDetailsContent.vendorDetailsContentConfirmButtonLabel
      }
      onCancelHandler={() => handleCancelDetailsModalClick(setIsDetailsModalOpen)}
      cancelActionLabel={stringsData.vendorDetailsContent.vendorDetailsContentCancelButtonLabel}
    >
      <AddOrEditVendorComponent
        stringsData={stringsData}
        formFieldsValues={formFieldsValues}
        setFormFieldsValues={setFormFieldsValues}
        formFieldsValidation={formFieldsValidation}
        vendorTypes={vendorTypes}
        handleDropDownFieldChange={handleDropDownFieldChange}
      />
    </Modal>
  </VendorsWrapper>
);

export default VendorsComponent;

VendorsComponent.propTypes = {
  stringsData: PropTypes.shape({
    vendorsHeader: PropTypes.shape({
      createVendorButton: PropTypes.string,
    }),
    vendorDetailsContent: PropTypes.shape({
      vendorDetailsContentCancelButtonLabel: PropTypes.string,
      vendorDetailsContentConfirmButtonLabel: PropTypes.string,
      vendorDetailsContentEditButtonLabel: PropTypes.string,
    }),
  }).isRequired,
  numberOfPages: PropTypes.number.isRequired,
  selectedPageFilter: PropTypes.number.isRequired,
  vendorsList: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  vendorTypes: PropTypes.arrayOf({}),
  mappedVendorsList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vendorStatusEnum: PropTypes.shape({}).isRequired,
  vendorStatusColorEnum: PropTypes.func.isRequired,
  handleVendorsGenericFilterChange: PropTypes.func.isRequired,
  handleVendorsSearchBarInputChange: PropTypes.func.isRequired,
  handleVendorsPaginationClick: PropTypes.func.isRequired,
  filters: PropTypes.shape({}),
  labsQueryStrings: PropTypes.shape({}).isRequired,
  formFieldsValues: PropTypes.shape({
    key: PropTypes.string,
  }).isRequired,
  setFormFieldsValues: PropTypes.func.isRequired,
  formFieldsValidation: PropTypes.shape({}).isRequired,
  isDetailsModalOpen: PropTypes.bool.isRequired,
  setIsDetailsModalOpen: PropTypes.func.isRequired,
  handleConfirmDetailsModalClick: PropTypes.func.isRequired,
  handleCancelDetailsModalClick: PropTypes.func.isRequired,
  handleVendorEditButtonClick: PropTypes.func.isRequired,
  handleDropDownFieldChange: PropTypes.func,
};

VendorsComponent.defaultProps = {
  filters: {},
  vendorTypes: [],
  handleDropDownFieldChange: () => {},
};
